import Highcharts, { width } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Funnel from "highcharts/modules/funnel";

// Load funnel module (pyramid comes from this)

const FinancePyramid = ({ totalApproved, totalUtilised, balance }) => {

    const options = {
        chart: {
            type: "pyramid",
            height: 300,
            width: 450,
            background: 'transparent'
        },

        title: {
            text: "",
        },

        tooltip: {
            pointFormat: "<b>{point.y} Cr</b>"
        },

        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    format: "<b>{point.name}</b> ({point.y} Cr)",
                    color: "#070707",
                    softConnector: true
                },
                center: ["50%", "55%"],
                width: "70%"
            }
        },

        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Finance",
                colorByPoint: true,
                data: [
                    {
                        name: "Total Approved",
                        y: totalApproved,
                        color: "#91e98e"   // 🔵 Blue
                    },
                    {
                        name: "Total Utilised",
                        y: totalUtilised,
                        color: "rgb(230, 174, 137)"   // 🟢 Green
                    },
                    {
                        name: "Remaining Balance",
                        y: balance,
                        color: "#f37272"   // 🟡 Yellow
                    }
                ]
            }
        ]

    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default FinancePyramid;
